// This icon file is generated automatically.
var PFileImageOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M7.64 6.95L6.43 8.5l-.65-.81a.12.12 0 00-.2 0L4.04 9.67c-.07.08 0 .2.1.2h5.75c.1 0 .16-.12.1-.2L7.83 6.95a.13.13 0 00-.2 0zM4.63 5.91a.62.62 0 101.24 0 .62.62 0 00-1.25 0zm7.72-2.4L9 .15A.5.5 0 008.64 0H2a.5.5 0 00-.5.5v13c0 .28.22.5.5.5h10a.5.5 0 00.5-.5V3.86a.5.5 0 00-.15-.35zm-1 .58H8.4V1.15l2.94 2.94zm.03 8.79H2.62V1.12h4.72V4.5c0 .36.3.66.66.66h3.38v7.71z", "fill-rule": "nonzero" } }] }, "name": "p-file-image", "theme": "outlined" };
export default PFileImageOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PFileImageOutlined.js
// module id = 3386
// module chunks = 0